import script from "./SelectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectPage.vue?vue&type=script&setup=true&lang=js"

import "./SelectPage.vue?vue&type=style&index=0&id=362e16fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362e16fa"]])

export default __exports__